<template>
  <FriendlierCard>
    <div class="padded-block">
      <div class="logo">
        <LocaleAwareLogo variant="primary" color="ocean" />
      </div>
      <h2 class="is-size-2 mb-4 mt-2 title">Forgot Password?</h2>
      <p class="is-cloud">Enter your email to reset password:</p>
      <form>
        <div class="friendlier-field">
          <p class="control">
            <span class="icon is-medium is-left mr-3">
              <FontAwesomeIcon icon="envelope" />
            </span>
            <input
              id="forgot-password-email"
              name="email"
              type="email"
              required
              placeholder="email"
              v-model="email"
              autocomplete="email"
              inputmode="email"
              autocapitalize="off"
              spellcheck="false"
              @input="handleEmailInput"
              @blur="handleEmailBlur"
              class="is-size-4 is-right p-2"
            />
          </p>
          <p v-if="emailSuggestion" class="email-suggestion">
            Did you mean
            <button type="button" class="email-suggestion-link" @click="applyEmailSuggestion">{{ emailSuggestion }}</button>?
          </p>
        </div>
        <button @click.prevent="submit" class="ocean-button mt-3 is-bold fs-1-2">Send</button>
        <p class="mt-2 is-sunflower" :class="{ alert: message.type == 'alert' }">
          {{ message.text }}
        </p>
      </form>
      <div @click="back" class="back m-5 is-sunflower">Back</div>
    </div>
  </FriendlierCard>
</template>
<script>
import { ref } from "vue";
import { FriendlierCard, LocaleAwareLogo } from "@/revamp/components";
import request from "@/revamp/utils/request";
import { getSuggestedEmail } from "@/revamp/utils";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: "ForgotPassword",
  props: {
    back: Function,
  },
  components: {
    FriendlierCard,
    LocaleAwareLogo,
    FontAwesomeIcon,
  },
  setup() {
    const message = ref({ type: null, text: "" });
    const email = ref("");
    const emailSuggestion = ref(null);
    const genericResetMessage = "If this email has an account, check your inbox for a reset password link";

    function handleEmailInput() {
      emailSuggestion.value = null;
    }

    function handleEmailBlur() {
      emailSuggestion.value = getSuggestedEmail(email.value);
    }

    function applyEmailSuggestion() {
      if (!emailSuggestion.value) return;
      email.value = emailSuggestion.value;
      emailSuggestion.value = null;
    }

    async function submit() {
      try {
        if (email.value == "") {
          message.value = { type: "alert", text: "Please enter an email" };
          return;
        }
        await request(
          `${process.env.VUE_APP_FIREBASE_FUNCTIONS_URL}/sendPasswordReset`,
          "POST",
          { email: email.value.trim().toLowerCase() },
          "ForgotPassword.submit",
          false
        );
        email.value = "";
        emailSuggestion.value = null;
        message.value = {
          type: "msg",
          text: genericResetMessage,
        };
      } catch (err) {
        console.log(`Failed ${err.toString()}`);
        email.value = "";
        emailSuggestion.value = null;
        message.value = { type: "msg", text: genericResetMessage };
      }
    }
    return {
      // Methods
      submit,
      handleEmailInput,
      handleEmailBlur,
      applyEmailSuggestion,
      // Data
      message,
      email,
      emailSuggestion,
    };
  },
};
</script>
<style lang="scss" scoped>
@import "@/revamp/assets/scss/colors.scss";
@import "@/revamp/assets/scss/elements.scss";

.padded-block {
  padding: 20px;
  width: 100%;
  text-align: center;
  position: relative;
  padding-bottom: 50px;
}

.title {
  color: $sunflower;
}

.logo {
  max-width: 30%;
  min-width: 300px;
  margin: 0 auto;
}

.alert {
  color: $sunrise;
}

.back {
  position: absolute;
  bottom: 0;
  right: 0;
  cursor: pointer;
  color: $denim;
}

.email-suggestion {
  margin-top: 0.5rem;
  color: #4a4a4a;
}

.email-suggestion-link {
  appearance: none;
  border: none;
  background: none;
  color: #0048b4;
  font: inherit;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;
}
</style>
